import React from 'react'

import "./Header.scss"
import Search from '../Search/Search'
import NavList from '../NavList/NavList'
import ProfileIcon from '../ProfileIcon/ProfileIcon'
import CartButton from '../CartButton/CartButton'
import ThemeSwitcher from '../ThemeSwitcher/ThemeSwitcher'
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import RoomOutlinedIcon from '@mui/icons-material/RoomOutlined';
import { Link } from 'react-router-dom'

const Header = () => {
    return (
        <header>
            <div className="header-top">
                    <div className="container">
                        <div className="header-item">
                            <div className="header-info">
                                <div className="visible">
                                    <p>Mon-Tue: <span className="header-info__time">9:00 AM - 5:30 PM</span></p>
                                </div>
                                <div className="hidden">
                                    <div className="header-info-pop">
                                        <div className="header-info-pop-block">
                                            <div className="icon">
                                                <AccessTimeIcon/>
                                            </div>
                                            <div className="info">
                                                <p>We are open:</p>
                                                <ul>
                                                    <li>Mon-Thu: 9:00 AM - 5:30 PM</li>
                                                    <li>Fr: 9:00 AM - 6:00 PM</li>
                                                    <li>Sat: 11:000 AM - 5:00 PM</li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="header-info-pop-block">
                                            <div className="icon">
                                                <RoomOutlinedIcon/>
                                            </div>
                                            <div className="info">
                                                <p>Address: 1234 Street Adress, City Address, 1234</p>
                                            </div>
                                        </div>
                                        <div className="header-info-pop-link">
                                            <p>Phone: <a href="/">(00) 1234 5678</a></p>
                                            <p>E-mail: <a href="/">shop@email.com</a></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="header-item">
                            <p>Visit our showroom in 1234 Street Adress City Address, 1234  <Link to='/contact'>Contact Us</Link></p>
                        </div>
                        <div className="header-item">Call Us: <a href="/">(00) 1234 5678</a></div>
                    </div>
                </div>
                <div className="header-wrapper">
                    <div className="container">
                        <div className="header-nav">
                            <div className="logo">
                                <img src={process.env.PUBLIC_URL + '/logo.svg'} alt="" />
                            </div>
                            <NavList/>
                        </div>
                        <div className="header-control">
                            <Search/>
                            <ThemeSwitcher/>
                            <CartButton/>
                            <ProfileIcon/>
                        </div>
                    </div>
            </div>
        </header>
    )
}

export default Header